import { CommonDialogs } from "@mcleod/common";
import { AutogenLayoutOrderMultiSelectErrorModal } from "./autogen/AutogenLayoutOrderMultiSelectErrorModal";
import { Layout, TableRow, Dialog, Component } from "@mcleod/components";
import { OrderMultiSelectErrorSlideout } from "./OrderMultiSelectErrorSlideout";
import { ModelRow } from "@mcleod/core";

const layoutPath = "lme/general/OrderMultiSelectErrorModal"
let modal: Dialog;

export class OrderMultiSelectErrorModal extends AutogenLayoutOrderMultiSelectErrorModal {
    public static async showModal(failedRows: TableRow[], errorRows: ModelRow[], successCount: number, title: string, slideoutButtonText: string, slideoutButtonAction: (selectedRows: TableRow[]) => any, addlComponents?: Component[], isOpsMgmt = false) {
        const modalLayout = Layout.getLayout(layoutPath) as OrderMultiSelectErrorModal;
        modal = CommonDialogs.createDialog(modalLayout, {
            centerInParent: true,
            title,
            panelTitleProps:{
                backgroundColor: "primary.darker",
                color: "primary.reverse"
            },
            movable: true
        })
        modalLayout.addLayoutDataLoadListener(() => {
            if (addlComponents) {
                modalLayout.add(...addlComponents);
            }
            modalLayout.labelSuccessfulOrderCount.text = successCount.toString();
            const failedCount = failedRows.length;
            const errorCount = errorRows?.length ?? 0;
            modalLayout.labelFailedOrderCount.text = failedCount.toString();
            const hasErrors = errorCount > 0
            modalLayout.labelErrorLink.visible = modalLayout.labelErrorPipe.visible = hasErrors;
            const retryCallback = (selectedRows: TableRow[]) => {
                modal.close();
                return slideoutButtonAction(selectedRows);
            };
            if (hasErrors) {
                modalLayout.labelErrorLink.addClickListener(() =>
                    OrderMultiSelectErrorSlideout.showSlideout(failedRows, errorRows, slideoutButtonText, retryCallback, isOpsMgmt));
            }
            if (failedCount > 0) {
                modalLayout.labelFailedOrderCount.color = "error";
                modalLayout.labelFailedLink.addClickListener(() =>
                    OrderMultiSelectErrorSlideout.showSlideout(failedRows, errorRows, slideoutButtonText, retryCallback, isOpsMgmt));
            }
            else {
                modalLayout.labelFailedLink.visible = modalLayout.labelFailedPipe.visible = false;
            }
        });
        modal.show();
    }
}
